import { FC, memo, useContext } from 'react';

import { Label } from '@smartshell/ui-kit';

import { AuthContext } from 'auth';
import { ClientsAvatar } from 'components';
import { LocalizationContext } from 'localization';
import { formatFIO, formatPhone } from 'utils';

import s from './Me.module.scss';

export const Me: FC = memo(() => {
  const { t } = useContext(LocalizationContext);

  const {
    data: { me },
  } = useContext(AuthContext);

  if (!me) return null;

  const isMyWorkshift = me.roles.some(
    ({ alias }) => alias === 'active_operator'
  );

  return (
    <div className={s.container}>
      <ClientsAvatar avatar={me?.avatar_url} roles={me?.roles} size="s" />

      <div className={s.data}>
        <span className={s.fio}>{formatFIO(me)}</span>
        <span className={s.phone}>{formatPhone(me.phone)}</span>
      </div>
      <Label
        text={t(isMyWorkshift ? 'workShifts.worker.me' : 'user.you')}
        color="gray-secondary"
        rounded
        className={s.label}
      />
    </div>
  );
});
